(function () {
	const initCollapsibleContent = (container = document) => {
		$(container)
			.find(".collapsible-content__toggle")
			.off("click.collapsible")
			.on("click.collapsible", function () {
				const parent = $(this).parent();

				if (!parent.hasClass("active")) {
					parent
						.siblings(".collapsible-content__item.active")
						.removeClass("active")
						.find(".collapsible-content__answer")
						.stop()
						.slideUp(300);

					parent.addClass("active");
					$(this).next().stop().slideDown(300);
				} else {
					parent.removeClass("active");
					$(this).next().stop().slideUp(300);
				}
			});
	};

	initCollapsibleContent();


	document.addEventListener("shopify:section:load", function (event) {
		initCollapsibleContent(event.target);
	});
})();
